// @flow
import { pxToRem } from '../util'

export const SPACING_UNIT = 8

export type SpacingSize =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | -1
  | -2
  | -3
  | -4
  | -5
  | -6

export const spacingPx = [
  /* 0:  0px */ 0,
  /* 1:  4px */ SPACING_UNIT / 2,
  /* 2:  8px */ SPACING_UNIT,
  /* 3: 16px */ SPACING_UNIT * 2,
  /* 4: 24px */ SPACING_UNIT * 3,
  /* 5: 48px */ SPACING_UNIT * 6,
  /* 6: 64px */ SPACING_UNIT * 8,
]

export const spacingRem = spacingPx.map(pxToRem)

export default (size: SpacingSize) =>
  size > 0 ? spacingRem[size] : `-${spacingRem[-size]}`



// WEBPACK FOOTER //
// ./src/style/constants/spacing.js